module.exports = __webpack_public_path__ + "static/media/IMAGE_3-ALMONDS_(GETTY)_desktop.afd845ff.jpg";